import React from "react";
import { Box, useTheme } from "@mui/material";

const IconWrapper = ({ children, size = "90px" }) => {
    const theme = useTheme();
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                borderRadius: "50%",
                border: `2px solid ${theme.palette.primary.main}`,
                width: size,
                height: size,
            }}
        >
            {children}
        </Box>
    );
}

export default IconWrapper;
